export default __webpack_public_path__ + "static/media/q7_04.383931c9.jpg";